"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var row_1 = __importDefault(require("./row"));
var store_search_result_store_1 = __importDefault(require("~/stores/search/store_search_result_store"));
var StoreSearchResult = (0, mobx_react_1.observer)(function (props) {
    var store = (0, mobx_react_1.useLocalStore)(function () {
        var store = new store_search_result_store_1.default(props.searchWords);
        store.init();
        return store;
    });
    return (react_1.default.createElement("div", null, store.stores.length !== 0 && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h2", { className: "headline_bu" }, "\u8CB7\u53D6\u696D\u8005\u4E00\u89A7"),
        store.stores.map(function (store, index) { return (react_1.default.createElement(row_1.default, { key: index, store: store, isSmartPhone: props.isSmartPhone })); }),
        store.hasNextPage && (react_1.default.createElement("div", { className: "coSearchStoreSearchResult-MoreButtonWrapper" },
            react_1.default.createElement("button", { type: "button", className: "coSearchStoreSearchResult-MoreButton", onClick: function () { store.loadNext(); } }, "\u3053\u3053\u304B\u3089\u7D9A\u304D\u3092\u8868\u793A")))))));
});
exports.default = StoreSearchResult;
